'use client'

import { useResponsiveSize } from "@/provider/useResponsiveSize"
import { useRouter } from "@/locales/routing"
import { useUserDetailStore } from "@/store/useUserDetailStore"
import { useUserStore } from "@/store/useUserStore"
import { ChevronDown } from "@/ui/icons/ChevronDown"
import { FAQ } from "@/ui/icons/FAQ"
import { Feedback } from "@/ui/icons/Feedback"
import { Logout } from "@/ui/icons/Logout"
import { Settings } from "@/ui/icons/Settings"
import { useCookieConsentStore } from "@/store/useCookieConsentStore"
import { Button, cn, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Image, useDisclosure } from "@heroui/react"
import { motion } from "framer-motion"
import { useLocale, useTranslations } from "next-intl"
import { textVariants } from "./SideBar"

export const UserAction = ({ triggerClass, triggerRadius, avatarClass, header = false, ...other }: any = {}) => {
  const size = useResponsiveSize(['sm'])
  const t = useTranslations('header')
  const tc = useTranslations('cookieConsent')
  const locale = useLocale()
  const router = useRouter()


  // 获取用户详情数据
  const [userName, avatar] = useUserDetailStore(
    (state) => [state.name, state.avatar],
  )
  // 退出登录
  const loginOut = useUserStore(state => state.unLogin)
  const clearDetail = useUserDetailStore(state => state.clearDetail)
  // 打开 Cookie 偏好设置
  const openCookieSettings = useCookieConsentStore(state => state.openSettings)

  const { isOpen, onOpen, onOpenChange } = useDisclosure()


  const menuList = [
    { icon: <Feedback />, name: t('userAction.feedback'), handle() { router.push('/feedback') } },
    { icon: <FAQ />, name: t("userAction.Faqs"), handle() { router.push('/faqs') } },
    { icon: <Settings />, name: t('userAction.Settings'), handle() { router.push('/profile/edit/account') } },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5Z" />
          <path d="M8.5 8.5v.01M16 15.5v.01M12 12v.01M11 17v.01M7 14v.01" />
        </svg>
      ),
      name: tc('manage'),
      handle() { openCookieSettings() },
    },
    {
      icon: <Logout />, name: t('userAction.Logout'), handle() {
        loginOut()
        clearDetail()
        window.open(location.origin + "/" + locale, "_self")
      }
    },
  ]

  return (
    <div {...other}>
      <Dropdown
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        classNames={{
          content: "bg-gray-bg",
        }}
      >
        <DropdownTrigger>
          {
            // 头部action时
            header && size === 'default' ?
              <Button
                isIconOnly
                className="bg-transparent w-9 min-w-9 h-9 "
                startContent={<Image
                  classNames={{
                    wrapper: 'w-9 min-w-9 h-9 !leading-[1.5]',
                  }}
                  radius="full"
                  src={avatar!} />}></Button>
              : <Button
                fullWidth
                className={cn("p-2 sm:w-[180px] h-auto min-w-[40px] overflow-visible justify-between ", triggerClass)}
                onPress={onOpen}
                disableAnimation
                disableRipple
                radius={triggerRadius}
                startContent={<Image src={avatar!} radius="full" classNames={{ wrapper: cn('flex-shrink-0 max-w-none w-6 h-6 overflow-hidden', avatarClass)}} />}
                endContent={<ChevronDown data-open={isOpen} width={20} className="data-[open=true]:rotate-180 transition-transform" />}
              >
                <motion.p variants={textVariants} className="flex-1 line-clamp-1 break-all text-left font-bold text-theme-primary hidden sm:block">{userName}</motion.p>
              </Button>
          }


        </DropdownTrigger>
        <DropdownMenu aria-label="Static Actions">
          {
            menuList.map(item =>
              <DropdownItem
                key={item.name}
                textValue={item.name}
                onPress={() => item.handle && item.handle()}
                className="px-[16px] py-[12px] rounded-full hover:bg-seleced-bg">
                <div className="flex gap-[110px] justify-between">
                  <span>{item.name}</span>
                  {item.icon}
                </div>
              </DropdownItem>
            )
          }

        </DropdownMenu>
      </Dropdown>
    </div>
  )
}